import tripTypesEnum from './trip-types-enum';

const TRIP_TYPES_MAP_SIMPLE = {
  [tripTypesEnum.ROUND_TRIP]: {
    copyID: 'APP_ROUNDTRIP',
    icon: 'arrowReturnTrip',
  },
  [tripTypesEnum.ONE_WAY]: {
    copyID: 'MENU_RESERVA_ONEWAY',
    icon: 'arrowSingleTrip',
  },
  [tripTypesEnum.MULTI_DESTINATION]: {
    copyID: 'APP_MULTICITY',
    icon: 'arrowMultiTrip',
  },
};

export default TRIP_TYPES_MAP_SIMPLE;